module.exports = __webpack_public_path__ + "static/media/dongyanshan_package.db78fe14.png";